import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import LoadingSpinner from '../LoadingSpinner';

/**
 * DeveloperRoute Component
 * 
 * A route wrapper that ensures the user is authenticated AND has developer privileges.
 * If the user is not authenticated, they are redirected to the login page.
 * If the user is authenticated but not a developer, they are redirected to the home page.
 * Shows a loading spinner while checking authentication status.
 * 
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Child components to render if user is a developer
 * @returns {JSX.Element} The developer content, a redirect to login, or a redirect to home
 */
const DeveloperRoute = ({ children }) => {
  const { user, isAuthenticated, loading } = useAuth();

  // Show loading spinner while checking authentication
  if (loading) {
    return <LoadingSpinner />;
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  // Redirect to home if not a developer
  if (user?.role !== 'developer') {
    return <Navigate to="/" />;
  }

  // Render children if authenticated and user is a developer
  return children;
};

export default DeveloperRoute; 